export default [
  {
    path: '/content/suggestions',
    name: 'content-suggestions',
    component: () => import('@/views/content/SuggestionList.vue'),
  },
  {
    path: '/content/suggestions/:id',
    name: 'content-suggestion-view',
    component: () => import('@/views/content/SuggestionView.vue'),
    meta: {
      navActiveLink: 'content-suggestions',
    },
  },
]
